import { Theme } from '@mui/material'

import makeStyles from '@mui/styles/makeStyles'

interface UserChannelStylesProps {
  canChangeChannel: boolean
  onDelete?: boolean
}

const useStyles = makeStyles<Theme, UserChannelStylesProps>(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column'
  },

  channelBlock: {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'default',

    '&:first-child': {
      marginTop: '0'
    }
  },

  addButton: {
    marginLeft: '8px',
    fontSize: theme.size.sm,
    color: theme.palette.primary.main,
    cursor: 'pointer',

    '&:hover': {
      textDecoration: 'underline'
    }
  },

  addButtonFaded: {
    opacity: '0.5',
    cursor: 'default',

    '&:hover': {
      textDecoration: 'none'
    }
  },

  noChannel: {
    fontSize: theme.size.sm,
    color: '#8F8F8F',
    cursor: 'default',
    marginTop: '8px',
    marginLeft: 8,
    opacity: '0.5'
  },

  channelRow: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '8px',
    marginLeft: ({ onDelete }) => !onDelete && 8,
    cursor: ({ canChangeChannel }) => (canChangeChannel ? 'pointer' : 'default')
  },

  channelName: {
    width: '64px',
    flexShrink: 0,
    fontSize: theme.size.sm,
    color: '#8F8F8F'
  },

  flag: {
    marginLeft: '8px',
    fontSize: theme.size.sm
  },

  channelValue: {
    marginLeft: '8px',
    maxWidth: '220px',
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    flex: 2
  },

  channelEndIcon: {
    marginLeft: '8px',
    minWidth: '16px'
  },

  statusIcon: {
    marginLeft: '8px',
    flexShrink: 0
  },

  optedOutIcon: {
    color: '#FF3B3B'
  },

  trashIcon: {
    marginLeft: '8px',
    cursor: 'pointer'
  },

  row: {
    display: 'flex',
    marginTop: '16px !important',
    alignItems: 'center'
  },

  icon: {
    minWidth: '16px',
    color: '#8F8F8F'
  },

  title: {
    marginLeft: '8px',
    fontSize: theme.size.sm,
    color: '#8F8F8F',
    cursor: 'default'
  },

  buttonMenuClass: {
    display: 'inline-flex',
    padding: 0
  }
}))

export default useStyles
